import axios from 'axios';

// Always use /api for the preview/production environment
// This works because vercel.json routes /api requests to the backend
const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 
    'Content-Type': 'application/json' 
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('moneymove_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('moneymove_token');
      localStorage.removeItem('moneymove_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

export const paymentsApi = {
  createSession: (data) => api.post('/payments/create-session', data),
  executePaypal: (paymentId, payerId) => 
    api.get(`/payments/execute-paypal?paymentId=${paymentId}&PayerID=${payerId}`),
  getStatus: (sessionId) => api.get(`/payments/status/${sessionId}`),
};

export const transfersApi = {
  create: (data) => api.post('/transfers/create', data),
  getHistory: () => api.get('/transfers/history'),
  getById: (id) => api.get(`/transfers/${id}`),
  track: (trackingNumber) => api.get(`/transfers/track/${trackingNumber}`),
};

export const servicesApi = {
  getAll: () => api.get('/services'),
  getOne: (type) => api.get(`/services/${type}`),
  calculateFee: (serviceType, amount) => 
    api.get(`/calculate-fee?service_type=${serviceType}&amount=${amount}`),
  convertCurrency: (amount, from, to) => 
    api.get(`/convert-currency?amount=${amount}&from_currency=${from}&to_currency=${to}`),
};

export const dataApi = {
  getCountries: () => api.get('/countries'),
  getCurrencies: () => api.get('/currencies'),
};

export const statsApi = {
  getOverview: () => api.get('/stats/overview'),
};

export const reportsApi = {
  downloadPdf: () => api.get('/reports/transactions', { responseType: 'blob' }),
  downloadTransferReceipt: (trackingNumber) => 
    api.get(`/reports/transfer/${trackingNumber}`, { responseType: 'blob' }),
};

export default api;